var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('HeaderBar'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-scroll-x-transition',{attrs:{"mode":"out-in","hide-on-leave":true}},[_c('router-view')],1)],1)],1),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }